export const notifications = {
  successDataUpdate: 'Die Daten werden erfolgreich geändert.',
  errorOnDataUpdate:
    'Wenn die Daten geändert werden, ist ein Fehler aufgetreten.',
  waitResponseIn24Hours:
    'Erwarten Sie die Antwort auf Ihre Einladung innerhalb von 72 Stunden.',
  workItemIsCanceled: 'Die Einladung wurde zurückgezogen',
  notificationDeleted: 'Benachrichtigung wird gelöscht',
  noNotifications: 'Sie haben keine Benachrichtigungen',
  workInviteRejected: 'Die Einladung wird abgelehnt',
  workStartOnArtistArrivalConfirm:
    'Die Arbeit beginnt ab dem Moment, in dem der Club Ihre Anwesenheit am Arbeitsplatz bestätigt.',
  giveResponseFormWorkItem:
    'Geben Sie innerhalb von 72 Stunden eine Antwort auf die Einladung. Nach 72 Stunden wird die Einladung gelöscht.',
  generalError: 'Etwas lief schief, versuche es später.',
  passwordReseted: 'Das Passwort wird fallen gelassen',
  languageSwitched: 'Die Sprache wird geändert',
  invitationExpired: 'Die Einladung lief ab',
  linkIsCopied: 'Der Link wird kopiert',
  accountIsVisible: 'Das Konto wird in der Suche angezeigt',
  hiringEnabled: 'Eine Reihe von Künstlern ist offen',
  hiringDisabled: 'Die Künstlergruppe ist geschlossen',
  rejectedForReason: 'Otclone wegen __var_0__',
  profileDeleted: 'Das Profil wird entfernt',
  accountHiddenFromSearch:
    'Das Konto ist versteckt und zeigt bei der Suche nach Künstlern nicht mehr an',
  registerRequestSended: 'Anmeldungsanfrage wurde gesendet',
  notFoundNotifications: 'Sie haben keine Benachrichtigungen',
  lastWorkDaySeted: 'Das letzte Arbeitsdatum wurde festgelegt'
};
